<div class="application-card">
  <div class="card-top">
    <h3 class="company-name">{{ companyName }}</h3>
    <span class="status-badge" [ngClass]="getStatusClass(application.applicationStatus)">
      {{ getStatusText(application.applicationStatus) }}
    </span>
  </div>

  <div class="divider"></div>

  <div class="meat-type">{{ getMeatTypeName() }}</div>

  <div class="requested-volume">
    <span class="volume-label">{{ 'quota.requestedVolume' | translate }}</span>
    <span class="volume-value">{{ getTons(application.requestedVolume) }} тонн</span>
  </div>

  @if (application.rejectionReason || application.underConsiderationReason) {
  <div class="notes">
    <span class="notes-label">{{ 'quota.note' | translate }}</span>
    <span class="notes-text">{{ application.rejectionReason || application.underConsiderationReason }}</span>
  </div>
  }

  <div class="card-footer">
    <button mat-stroked-button class="detail-btn" (click)="openDetail()">Подробнее</button>
  </div>
</div>
